/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import ExtraFields from './ExtraFields/index'
import React from 'react'
import ReusuableToggle from './ReusuableToggle/index'
import TestInfo from './TestInfo/index'
import WidgetPlaceholder from './WidgetPlaceholder/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/PaymentProvider/PaymentProviderCaptureMethod/Content"
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<ExtraFields
  viewPath={`${viewPath}/ExtraFields`}
/>
<WidgetPlaceholder
  viewPath={`${viewPath}/WidgetPlaceholder`}
/>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 style={{'--mt-1-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--mb-2-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal}`}
>
<ReusuableToggle
  viewPath={`${viewPath}/ReusuableToggle`}
/>
<TestInfo
  viewPath={`${viewPath}/TestInfo`}
/>
</div>
{children}
</React.Fragment>)
}